import React from "react";

function IcInfo() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="none"
      viewBox="0 0 24 24"
    >
      <path
        fill="#24206B"
        fillRule="evenodd"
        d="M2.39 10.486a.963.963 0 01-.93-1.215 10.948 10.948 0 013.835-5.755 10.83 10.83 0 016.67-2.283 10.856 10.856 0 019.034 4.814 10.812 10.812 0 011.466 3.202.963.963 0 11-1.86.506 9.01 9.01 0 00-3.16-4.723 8.866 8.866 0 00-5.48-1.872c-2.008 0-3.906.649-5.488 1.878A9.01 9.01 0 003.32 9.774a.964.964 0 01-.93.712zm9.575 12.51A10.885 10.885 0 011.44 14.885a.963.963 0 111.863-.49 8.957 8.957 0 008.662 6.674 8.957 8.957 0 008.662-6.673.964.964 0 011.863.489 10.885 10.885 0 01-10.525 8.11zM11 8a1 1 0 112 0v4a1 1 0 11-2 0V8zm1 9a1 1 0 100-2 1 1 0 000 2z"
        clipRule="evenodd"
      ></path>
      <mask
        style={{ maskType: "alpha" }}
        width="22"
        height="22"
        x="1"
        y="1"
        maskUnits="userSpaceOnUse"
      >
        <path
          fill="#fff"
          fillRule="evenodd"
          d="M2.39 10.486a.963.963 0 01-.93-1.215 10.948 10.948 0 013.835-5.755 10.83 10.83 0 016.67-2.283 10.856 10.856 0 019.034 4.814 10.812 10.812 0 011.466 3.202.963.963 0 11-1.86.506 9.01 9.01 0 00-3.16-4.723 8.866 8.866 0 00-5.48-1.872c-2.008 0-3.906.649-5.488 1.878A9.01 9.01 0 003.32 9.774a.964.964 0 01-.93.712zm9.575 12.51A10.885 10.885 0 011.44 14.885a.963.963 0 111.863-.49 8.957 8.957 0 008.662 6.674 8.957 8.957 0 008.662-6.673.964.964 0 011.863.489 10.885 10.885 0 01-10.525 8.11zM11 8a1 1 0 112 0v4a1 1 0 11-2 0V8zm1 9a1 1 0 100-2 1 1 0 000 2z"
          clipRule="evenodd"
        ></path>
      </mask>
    </svg>
  );
}

export default IcInfo;



// WEBPACK FOOTER //
// ./src/app/elements/Icon/ic-info.js